// IconJim — símbolo minimalista tech do assistente operacional.
// "J" outline arredondado com hook na base, escalável e herda cor.
export default function IconJim({ size = 18, color = 'currentColor', filled = false }: {
  size?: number;
  color?: string;
  filled?: boolean;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? color : 'none'}
      stroke={color}
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      aria-hidden="true"
    >
      {/* "J" minimalista: barra superior horizontal + haste descendente + curva final */}
      <path d="M8 4 L18 4" />
      <path d="M14 4 L14 16 A4 4 0 0 1 6 16" />
      {/* Ponto interno (toque tech) */}
      <circle cx="14" cy="9" r="0.8" fill={color} stroke="none" />
    </svg>
  );
}
